// 給前端頁面使用
// 前端頁面可實作 onRenewTokenInfo, 當tokenInfo更新時會觸發
window.host_renewTokenInfo_callback = function(tokenInfo) {
  localStorage.setItem('tokenInfo', tokenInfo)
  if (window.onRenewTokenInfo != null) {
    window.onRenewTokenInfo.call(this)
  }
}
// 提供給app host_login callback 的後續動作
window.host_login_callback = function(tokenInfo) {
  localStorage.setItem('tokenInfo', tokenInfo)
  if (window.onRenewTokenInfo != null) {
    window.onRenewTokenInfo.call(this)
  }
}

window.onRenewTokenInfo = function() {
  // location.reload()
}

// 這邊預期會等到第1次host_renewTokenInfo過，才來取值
window.host_getTokenInfo = function() {
  // if (localStorage.getItem('USE_TOKENAPI')) {
  //   const item = localStorage.getItem('tokenInfoAPI')
  //   return item
  // }
  if (typeof window.host_renewTokenInfo != 'undefined') {
    window.host_renewTokenInfo()
  }
  const item = localStorage.getItem('tokenInfo')
  if (item == null) {
    const previewToken = getUrlPara('pt')
    if (previewToken != '') {
      localStorage.setItem('tokenInfo', previewToken)
      return previewToken
    }
    return 'QwsQJLElyZndrrQ2SI5hksO+zadcy6UuXDL9pQoSLR0ZaKrOLckZQAWPylMLjPHCOaQCLU/nDx2zgIWdHuKOyy9mrrLCFjvjmnhYGwtaLbxNCgH7ldXiSv2noBSioqks+IOGEpuh7lZ+xrgFZvyGnA1UZyzeF6IFI0IzYZeak4uHtEiVQxOatcTFOqWGrtPT'
  } else {
    const previewToken = getUrlPara('pt')
    if (previewToken != '' && previewToken != item) {
      localStorage.setItem('tokenInfo', previewToken)
    }
  }
  return item
}

/**
 * @param {string} name The parameter name.
 * @return {string} value.
 */
function getUrlPara(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
  const regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
  const results = regex.exec(location.href)
  if (results === null) {
    return ''
  } else {
    return decodeURIComponent(results[1].replace(/\+/g, ' '))
  }
}
